<template>
  <div :class="$store.state.isPc ? 'sming' : 'mobile_sming'">
    <div class="header"><NavBar></NavBar></div>
    <keep-alive>
      <router-view />
    </keep-alive>
    <Footer></Footer>
  </div>
</template>

<script>
import NavBar from "./components/NavBar.vue";
import Footer from "./components/footer.vue";

export default {
  name: "App",
  components: {
    NavBar,
    Footer,
  },
  computed: {
    key() {
      return this.$route.fullPath;
    },
  },
};
</script>

<style scoped>
@import "@/assets/css/base.scss";
.header {
  position: fixed;
  top: 0px;
  width: 100%;
  height: 90px;
  background-color: white;
  z-index: 1000;
}
.sming {
  width: 100%;
  overflow-x: hidden;
  padding-top: 90px;
}

.mobile_sming {
  width: 100vw;
}
</style>
